import React from "react";
import "./PhoneSection.css";
import pngImage from "../assets/3p_phone/1.png"
import gifImage from "../assets/3p_phone/1.gif"; // 나중에 전달받을 GIF 파일 경로

function PhoneSection() {
  return (
    <section className="phone-section">
      <div className="phone-section-gif-container1">
        <img src={pngImage} alt="소개 텍스트" />
      </div>
      <div className="phone-section-gif-container2">
        <img src={gifImage} alt="번호 목록 내려가는 영상 구현" />
      </div>
    </section>
  );
}

export default PhoneSection;
